import { Box, Text, Tooltip } from '@frontend/components';

import {
  FeatureFlagType,
  FeatureFlagData,
} from 'modules/common/drawers/featureFlagDrawer/types';

import { getTierIcon, getTierStatus } from '../FormFieldRow';

type TierCellProps = {
  tierInfo: {
    default?: boolean | number | string;
    upsell: boolean;
  };
  tierName: string;
  type: FeatureFlagData['type'];
  contracted: boolean;
};

export const TierCell = ({
  tierInfo,
  tierName,
  type,
  contracted,
}: TierCellProps) => {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      verticalAlign="middle"
    >
      {tierInfo.default !== undefined ? (
        <>
          {type === FeatureFlagType.Boolean ? (
            <Tooltip
              label={`${tierName}: ${getTierStatus(
                tierInfo,
                tierName,
                contracted,
              )}`}
            >
              {getTierIcon(tierInfo, contracted)}
            </Tooltip>
          ) : (
            <Tooltip
              label={
                tierInfo.upsell
                  ? 'Upsell for more'
                  : `${tierName}: ${tierInfo.default}`
              }
            >
              <Text
                fontSize="sm"
                color={tierInfo.upsell ? 'alert.warning' : undefined}
                fontWeight={tierInfo.upsell ? 'medium' : undefined}
              >
                {String(tierInfo.default)}
              </Text>
            </Tooltip>
          )}
        </>
      ) : (
        <Tooltip label={`${tierName}: as required by configuration`}>
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            boxSize={3}
            flexShrink={0}
          >
            <Box
              width="18px"
              height="18px"
              borderRadius="full"
              bg="page.plateMedium"
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
